import BrokerageProfileBase from './../shared/brokerageprofile-base';

export default class BrokerageProfileModel extends BrokerageProfileBase {
    constructor(...args) {
        super(...args);
    }
}



// WEBPACK FOOTER //
// ./src/agent-profile/brokerage-profile-model.js